import { BookingScheduleInterface } from "../../../../features/Booking-Form/typings/booking.types";

/**
 * check if schedules have doorLock data then show the fast lock icon
 */
export function filterUnlockableSchedule({
  schedules,
  setUnlockableSchedules
}: {
  schedules: BookingScheduleInterface[];
  setUnlockableSchedules: (t: BookingScheduleInterface[] | undefined) => void;
}) {
  const unlockables = schedules.filter(
    schedule => schedule.doorLockData && schedule.doorLockData?.length >= 1
  );
  if (unlockables.length > 0) setUnlockableSchedules(unlockables);
  else setUnlockableSchedules(undefined);
}
